module.exports = __webpack_public_path__ + "static/language-icons-3f50a49a3cd01c2cb670b5ac493a3ed9.png";